import api from './api';

// Global izin politikası şablonları. Kiracıya ait DEĞİL — okuma herkese açık,
// yazma yalnız superAdmin (backend zorluyor).
export const getLeavePolicyTemplates = () => api.get('/v1/leave-policy-templates');
export const getLeavePolicyTemplate = (id) => api.get(`/v1/leave-policy-templates/${id}`);
export const createLeavePolicyTemplate = (data) => api.post('/v1/leave-policy-templates', data);
export const updateLeavePolicyTemplate = (id, data) => api.put(`/v1/leave-policy-templates/${id}`, data);
export const deleteLeavePolicyTemplate = (id) => api.delete(`/v1/leave-policy-templates/${id}`);
